/**
 * User-friendly messages for image upload / analysis errors.
 */
export const getUploadErrorMessage = (error) => {
  const status = error?.response?.status;

  if (status === 413) {
    return (
      "Foto terlalu besar untuk diupload. " +
      "Coba ambil ulang dari jarak lebih dekat atau gunakan resolusi kamera lebih rendah."
    );
  }

  if (error?.message) {
    return error.message;
  }

  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") {
    return detail;
  }

  return "Gagal mengupload foto. Silakan coba lagi.";
};
